var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 26,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A2D6E6",
  d: "M2.5.5A2.497 2.497 0 0 0 .013 3L0 23c0 1.375 1.113 2.5 2.488 2.5H17.5c1.375 0 2.5-1.125 2.5-2.5V8L12.5.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6AB9D2",
  d: "M11 8.5v-7l8 8h-7a1 1 0 0 1-1-1"
})));
export default SvgSvgFile;